var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 503,
    viewBox: "0 0 205 503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.766,
    cy: 298.39,
    rx: 8.52,
    ry: 8.525
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.766,
    cy: 332.492,
    rx: 8.52,
    ry: 8.525
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.14,
    cy: 298.39,
    rx: 8.52,
    ry: 8.525
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.14,
    cy: 332.492,
    rx: 8.52,
    ry: 8.525
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M76.846 0a8.515 8.515 0 0 0-8.52 8.525v110.83c0 11.101-7.148 20.479-17.04 24.009V8.525A8.515 8.515 0 0 0 42.766 0a8.515 8.515 0 0 0-8.52 8.525v134.839c-9.891-3.53-17.04-12.908-17.04-24.008V8.526A8.515 8.515 0 0 0 8.686 0a8.515 8.515 0 0 0-8.52 8.525v110.83c0 20.581 14.663 37.803 34.08 41.767v87.326c-14.654 3.81-25.56 17.042-25.56 32.891v187.56c0 18.806 15.285 34.101 34.08 34.101 18.795 0 34.08-15.295 34.08-34.102V281.34c0-15.849-10.905-29.08-25.56-32.891v-87.326c19.417-3.964 34.08-21.177 34.08-41.766V8.526A8.515 8.515 0 0 0 76.846 0zm-17.04 281.339v187.56c0 9.403-7.642 17.05-17.04 17.05-9.397 0-17.04-7.647-17.04-17.05v-187.56c0-9.404 7.643-17.05 17.04-17.05 9.398 0 17.04 7.646 17.04 17.05zM187.112 14.34C177.52 4.689 163.776 0 145.1 0a8.515 8.515 0 0 0-8.52 8.525v247.238c0 .929.256 1.782.528 2.617-5.563 6.07-9.048 14.084-9.048 22.959v187.56c0 18.806 15.285 34.101 34.08 34.101 18.795 0 34.08-15.295 34.08-34.102V281.34c0-10.921-5.248-20.555-13.257-26.804 21.734-28.168 21.794-69.832 21.777-130.405l.051-18.807c.205-40.683.384-72.816-17.679-90.983zm-7.932 454.558c0 9.404-7.642 17.051-17.04 17.051s-17.04-7.647-17.04-17.05v-187.56c0-9.404 7.642-17.05 17.04-17.05s17.04 7.646 17.04 17.05v187.56zm8.571-363.66l-.051 18.9c.017 59.969-.043 100.115-21.223 123.543-1.432-.188-2.855-.444-4.337-.444-2.956 0-5.777.495-8.52 1.21V17.555c9.457 1.057 16.554 3.922 21.41 8.807 13.062 13.146 12.909 42.15 12.721 78.877z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantLine);
export default __webpack_public_path__ + "static/media/restaurant-line.3161158dfe13e95051ba057ca6fcaa0e.svg";
export { ForwardRef as ReactComponent };